import { useEffect, useRef, useState } from 'react';
import styles from './members.module.scss';
import * as React from 'react';
import ViewProfile from '../../components/prefabs/view-profile-popover/view-profile-popover';
import { Box } from '@mui/material';
import MemberFilter from '../../components/prefabs/member-filter/member-filter';
import { IPaginate, IQueryParams, TUser } from '../../models/common';
import dbService from '../../services/database.service';
import UserCard from '../../components/organisms/user-card/user-card';
import InfiniteScroll from 'react-infinite-scroll-component';
import { WSkeleton } from '../../components/wrappers/wrapper';
import useDeviceType from 'custom-hooks/useDeviceType';

let lastFetchTime = Date.now();
function MembersPage() {
  const { isTablet } = useDeviceType();
  const FETCH_LIMIT = isTablet ? 18 : 20;
  const defaultFilter: IQueryParams = {
    relation: true,
    paginate: true,
    limit: FETCH_LIMIT,
    sort: { _id: -1 },
  };

  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const [data, setData] = useState<TUser[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [userId, setUserId] = useState('');
  const [openInspectProfile, setOpenInspectProfile] = React.useState(false);
  const [filter, setFilter] = useState<IQueryParams>(defaultFilter);
  const [skip, setSkip] = useState(0);

  useEffect(() => {
    fetchData();
  }, [filter]);

  const fetchData = async () => {
    if (!canFetch()) return;

    const resPaginate = await dbService
      .getUsers({ ...filter, skip })
      .then((res) => res as unknown as IPaginate<TUser>);

    setSkip((prevSkip) => prevSkip + FETCH_LIMIT);

    setData((prev) => [...prev, ...resPaginate.data]);

    if (resPaginate.data.length < FETCH_LIMIT) {
      setHasMore(false);
    }
  };

  const handleOpenInspectProfile = (user_id: string) => {
    setUserId(user_id);
    setOpenInspectProfile(true);
  };

  const handleFilterChange = (newFilter: IQueryParams) => {
    setData([]);
    setHasMore(true);
    setSkip(0);
    scrollToTop();
    setFilter({ ...defaultFilter, filter: newFilter });
  };

  const scrollToTop = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const canFetch = () => {
    if (Date.now() - lastFetchTime > 10) {
      lastFetchTime = Date.now();
      return true;
    }
  };

  return (
    <div className={styles.container}>
      <MemberFilter onFilterChanged={handleFilterChange} />

      <div
        ref={scrollContainerRef}
        id="scrollableDiv"
        style={{
          height: window.innerHeight - 184,
          overflow: 'auto',
          display: 'flex',
        }}
      >
        <InfiniteScroll
          dataLength={data.length}
          next={fetchData}
          loader={
            <div className={styles.skeleton}>
              {[...Array(isTablet ? 6 : 8)].map((_, index) => (
                <WSkeleton key={index} variant="rounded" width={'100%'} height={273} />
              ))}
            </div>
          }
          className={styles.outlet}
          scrollableTarget="scrollableDiv"
          hasMore={hasMore}
        >
          <Box className={styles['member-box']}>
            {openInspectProfile && (
              <ViewProfile
                user_id={userId}
                onClose={() => setOpenInspectProfile(false)}
                showEditButton={false}
              ></ViewProfile>
            )}

            {!!data.length && (
              <div className={styles.list}>
                {data.map((user: any, index: any) => (
                  <UserCard
                    key={index}
                    user={user}
                    index={index}
                    onClick={() => handleOpenInspectProfile(user._id)}
                  />
                ))}
              </div>
            )}
          </Box>
        </InfiniteScroll>
      </div>
    </div>
  );
}
export default MembersPage;
